import { render, staticRenderFns } from "./SmbTextInput.vue?vue&type=template&id=6f0d922e&scoped=true&"
import script from "./SmbTextInput.vue?vue&type=script&lang=ts&"
export * from "./SmbTextInput.vue?vue&type=script&lang=ts&"
import style0 from "./SmbTextInput.scss?vue&type=style&index=0&id=6f0d922e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d922e",
  null
  
)

export default component.exports